<template>
</template>

<script>
  import Logout from './Logout.ts'
  export default Logout
</script>
